import belt from '../assets/images/belt roller .jpeg';
import con from '../assets/images/belt_convayer_roller.JPG';
import bottom from '../assets/images/bottom guide roller.png';
import cone from '../assets/images/Cone roller.JPG';
import drum from '../assets/images/Conveyor  Drum Pulley.jpg';
import HEad from '../assets/images/Conveyor HEad Crum Pulley.jpg';
import impact from '../assets/images/conveyor-impact-rollers-with stand.jpg';
import impc from '../assets/images/conveyor-impact-rollers.jpg';
import taper from '../assets/images/conveyor-taper-roller.jpg';
import Pan from '../assets/images/deep-pan-conveyor-roller.png';
import pull from '../assets/images/Drum Pulley.jpg';
import gate from '../assets/images/gate Guide.JPG';
import roll from '../assets/images/guide roller.jpg';
import rolle from '../assets/images/guide-roller.jpg';
import wheel from '../assets/images/guide-wheels.png';
import heko from '../assets/images/HEko Rollers_2.JPG';
import HEko from '../assets/images/HEko Rollers.JPG';
import sel from '../assets/images/self aligning return idler (1).jpg';
import alig from '../assets/images/self align conveyor roller.JPG';
import simpl from '../assets/images/Simple Taper roller.JPG';
import trommel from '../assets/images/trommel-guide roller.jpg';
import trommell from '../assets/images/trommel Carrying roller.JPG';
import Apron from '../assets/images/apron-feeder_guide roller .jpg';
import apron from '../assets/images/Apron feeder roller .jpg';

const Products5 = [
  { id: 1, name: 'Belt Roller', image: belt },
  { id: 2, name: 'Belt Convayer Roller', image: con },
  { id: 3, name: 'Bottom Guide Roller', image: bottom },
  { id: 4, name: 'Cone roller', image: cone },
  { id: 5, name: 'Conveyor  Drum Pulley', image: drum  },
  { id: 6, name: 'Conveyor HEad Crum Pulley', image: HEad },
  { id: 7, name: 'Conveyor Impact Rollers With Stand', image: impact },
  { id: 2, name: 'Conveyor Impact Rollers', image: impc },
  { id: 3, name: 'Conveyor Taper Roller', image: taper },
  { id: 4, name: 'Deep Pan Conveyor Roller', image: Pan },
  { id: 5, name: 'Drum Pulley', image: pull },
  { id: 6, name: 'Gate Guide', image: gate },
  { id: 6, name: 'Guide roller', image: roll },
  { id: 6, name: 'guide-roller', image: rolle },
  { id: 6, name: 'Guide Wheels', image: wheel },
  { id: 6, name: 'HEko Rollers', image: heko },
  { id: 6, name: 'Rollers Section', image: HEko },
  { id: 6, name: 'Self Aligning Return Idler', image: sel },
  { id: 6, name: 'Self Aligning Return Idler', image: alig },
  { id: 6, name: 'Simple Taper Roller', image: simpl },
  { id: 6, name: 'Trommel Guide Roller', image: trommel },
  { id: 6, name: 'Trommel Carrying Roller', image: trommell },
  { id: 6, name: 'Apron Feeder Guide Roller', image: apron },
  { id: 6, name: 'Apron Feeder Roller', image: Apron },

];


export default Products5;